/**
 * Company Profile Service
 *
 * Service untuk mengakses API Company Profile.
 */

import api from '@/services/api';
import type {
  UpdateCompanyProfileRequest,
  CompanyProfileResponse
} from '@/modules/file/types';

const companyService = {
  /**
   * Get company profile data
   */
  async get(): Promise<CompanyProfileResponse> {
    const response = await api.get<CompanyProfileResponse>('/company-profile');
    return response.data;
  },

  /**
   * Update company profile
   */
  async update(data: UpdateCompanyProfileRequest): Promise<CompanyProfileResponse> {
    const response = await api.put<CompanyProfileResponse>('/company-profile', data);
    return response.data;
  },

  /**
   * Upload company logo
   */
  async uploadLogo(file: File): Promise<{ success: boolean; logoUrl: string }> {
    const formData = new FormData();
    formData.append('logo', file);

    const response = await api.post<{ success: boolean; logoUrl: string }>(
      '/company-profile/logo',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  },

  /**
   * Delete company logo
   */
  async deleteLogo(): Promise<{ success: boolean }> {
    const response = await api.delete<{ success: boolean }>('/company-profile/logo');
    return response.data;
  }
};

export default companyService;
